export enum DRUG_COVERAGE_STATUS_ENUM {
  COVERED = 'Covered',
  GENERIC_COVERED = 'GenericCovered',
  NOT_COVERED = 'NotCovered',
  DATA_NOT_PROVIDED = 'DataNotProvided'
}

export interface DrugAutoCompleteItem {
  DrugID: number;
  DrugName: string;
  DrugTypeID: number;
  shouldDisplay: boolean;
}

export interface IndividualDrugItem {
  full_name: string;
  name: string;
  route: string;
  rxcui: string;
  rxnorm_dose_form: string;
  rxterms_dose_form: string;
  strength: string;
}

export interface IndividualDrugCoverageResponse {
  coverage: IndividualDrugCoverageData[];
}

export interface IndividualDrugCoverageData {
  coverage: DRUG_COVERAGE_STATUS_ENUM;
  plan_id: string;   // will match to hios id (or whatever value is used in the request payload)
  rxcui: string;
  generic_rxcui: string;
}
